import { Box, ListItemButton, Stack, Typography, useTheme } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";

import Context from "../../context";
import EntitiesSelectedRow from "./EntitiesSelectedRow";

// ----------------------------------------------------------------------

type Props = {
	title: string;
	description: string;
	isSelected?: boolean;
	id: string;
};

export const ConfigItem = ({ title, description, isSelected, id }: Props) => {
	const { actions } = useContext(Context);
	const theme = useTheme();

	const onClick = (e: any) => {
		e.preventDefault();
		actions.onSelectConfig(id);
	};

	return (
		<ListItemButton
			sx={{
				p: 3,
				boxShadow: theme.customShadows.card,
				borderRadius: 1.5
			}}
			onClick={onClick}
		>
			<Stack width={"100%"}>
				<Box display={"flex"} flexDirection='row' alignItems={"flex-start"} gap={2}>
					<Stack sx={{ mt: 0.4 }}>
						<Iconify
							icon={isSelected ? "icon-park-solid:check-one" : "akar-icons:radio"}
							width={18}
							height={18}
							color={isSelected ? "success.main" : "text.secondary"}
						/>
					</Stack>
					<Stack>
						<Typography variant='subtitle1'>{title}</Typography>
						<Typography variant='body2' color='text.secondary'>
							{description}
						</Typography>
						{id === "CUSTOM" && <EntitiesSelectedRow />}
					</Stack>
				</Box>
			</Stack>
		</ListItemButton>
	);
};

export default ConfigItem;
